import wait from 'wait-promise';
import reportError from 'ha/helpers/bugsnag/reportError';

export default config => {
  const callbacks = [];
  const userDependantCallbacks = [];

  let userIdentified = false;
  let isAnalyticsReady = false;
  let initialisationPromise;

  function runUserIdentifiedCallbacks() {
    if (global.mixpanel) {
      userDependantCallbacks.forEach(cb => cb(global.mixpanel));
      userDependantCallbacks.length = 0;
    }
  }

  return {
    init: () => {
      try {
        if (!config.analytics.enabled) return Promise.resolve();
        if (initialisationPromise) return initialisationPromise;

        global.analytics.ready(() => {
          isAnalyticsReady = true;
        });

        global.analytics.load(config.analytics.key);

        initialisationPromise = wait
          .before(config.waitBefore || 10000)
          .until(() => isAnalyticsReady)
          .catch(() => {
            if (config.debug) {
              reportError({
                name: 'Segment',
                message: 'Initialisation failed by timeout',
              });
            }
          })
          .then(() => {
            callbacks.forEach(callback => callback(global.mixpanel));
            callbacks.length = 0;

            return global.mixpanel;
          });

        return initialisationPromise;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    onReady: callback => {
      callbacks.push(callback);
    },
    onUserIdentified: callback => {
      if (userIdentified) {
        callback();
      } else {
        userDependantCallbacks.push(callback);
      }
    },
    identifyUser: () => {
      runUserIdentifiedCallbacks();
      userIdentified = true;
    },
  };
};
